enum ThemeType {
  Light
}

export default ThemeType;
